import { faBuildingFlag, faCircle, faCrown, faGrid2Plus } from '@fortawesome/pro-solid-svg-icons';

export const SENDER_TYPE_CORPORATE = 'corporate';
export const SENDER_TYPE_ORG_UNIT = 'org_unit';
export const SENDER_TYPE_GROUP = 'group';

export const SENDER_TYPES = [
    {
        label: 'Corporate',
        value: SENDER_TYPE_CORPORATE,
        color: 'text-amber-400',
        icon: faCrown,
    },
    {
        label: 'Organizational Unit',
        value: SENDER_TYPE_ORG_UNIT,
        color: 'text-violet-500',
        icon: faBuildingFlag,
    },
    {
        label: 'Group',
        value: SENDER_TYPE_GROUP,
        color: 'text-slate-400',
        icon: faGrid2Plus,
    },
] as const;

export function senderTypeLabel(senderType: SenderType) {
    const item = SENDER_TYPES.find((type) => type.value === senderType);

    return item?.label || 'Unknown';
}

export function getSenderTypeOption(senderType: SenderType) {
    const item = SENDER_TYPES.find((type) => type.value === senderType);
    return (
        item || {
            label: 'Unknown',
            value: senderType,
            color: 'text-slate-400',
            icon: faCircle,
        }
    );
}

export type SenderType = (typeof SENDER_TYPES)[number]['value'];
